module.exports = __webpack_public_path__ + "pausew.svg?e9f3fd531bf678851379b69837d99494";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pausew.svg
// module id = 14
// module chunks = 0